import { Box, Card, CardHeader, CardHeaderTypeMap } from '@mui/material';
// eslint-disable-next-line import/no-unresolved
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppPrimaryButton } from 'shared/components/AppComponents';
import { BaseApplicationState } from 'state/baseapplication/Reducer';

// eslint-disable-next-line @typescript-eslint/ban-types
type CardMember = OverridableComponent<CardHeaderTypeMap<{}, 'div'>>;

const CardEmployeeManage: CardMember = CardHeader;

const EmployeeManagementCard: React.FC<any> = () => {
  const navigation = useNavigate();
  const actionOnManageEmployees = (): void => {
    navigation('/manage-employees');
  };
  const actionOnManageTeam = (): void => {
    navigation('/manage-team');
  };
  const { orgACLConfig }: BaseApplicationState = useSelector(
    (state: any) => state.baseAppState
  );
  return (
    <Box className="employee-management-wrapper">
      <Card variant="outlined">
        <CardHeader title="Employee & User Management" />
        <CardEmployeeManage
          title="Employee Management"
          subheader="Manage employees for policy acknowledgements and training assignments."
          action={
            orgACLConfig.settings?.includes(
              'settings.management.manageEmployees'
            ) && (
              <AppPrimaryButton
                title="Manage Employees"
                onClick={actionOnManageEmployees}
                sx={{ background: '#06362b !important' }}
              />
            )
          }
        />
        <CardEmployeeManage
          title="Team Management"
          subheader="Invite new team members and manage existing ones."
          action={
            orgACLConfig.settings?.includes(
              'settings.management.manageTeam'
            ) && (
              <AppPrimaryButton
                title="Manage Team"
                onClick={actionOnManageTeam}
                sx={{ background: '#06362b !important' }}
              />
            )
          }
        />
      </Card>
    </Box>
  );
};

export default EmployeeManagementCard;
